<template>
  <div :class="'main-' + theme">
    <card :class="'main-'+theme">
      <h4
        class="card-title text-center"
        :class="'title-'+theme"
      >Catalogador de Velas & Ciclos da Teoria Cutrim</h4>
      <hr />
      <!-- CATA-CANDLE SYSTEM -->
    </card>
    <div class="row col-md-12 col-sm-12">
      <div class="col-md-3 col-sm-12">
          <div class="row card-boby justify-content-center">
            <div class="col-md-12">
              <h4 class="card-title">
                <small :class="'title-'+theme">Preencha todos os campos abaixo:</small>
              </h4>
              <card class="stacked-form" :class="'card-catalog-'+theme">
                <form @submit.prevent="onSubmitForm">
                  <div>
                    <div class="row">
                      <div class="col-md-12" style="padding: 10px 10px 0px 10px">
                        <label>QTD. Inicial de Velas:</label>
                        <br />
                        <fg-input
                          type="number"
                          tabindex="2"
                          v-model="howManyCandles"
                          placeholder="120 (Recomendado)"
                        ></fg-input>
                      </div>
                      <div class="col-md-12" style="padding: 10px 10px 10px 10px">
                        <label>Período (timeframe):</label>
                        <br />
                        <el-select
                          class="col-md-12 select-"
                          style="padding: 0px 0px 0px 0px"
                          :class="theme === 'black' ? 'azure' : 'primary'"
                          size="large"
                          tabindex="3"
                          placeholder="Selecione aqui..."
                          v-model="selectedCandleTime"
                        >
                          <el-option
                            v-for="option in selects.candleTimes"
                            class="col-md-12 select-"
                            :class="theme === 'black' ? 'azure' : 'primary'"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-12" style="padding: 10px 10px 0px 10px">
                        <label>Horário Inicial (Catalogação):</label>
                        <br />
                        <fg-input type="time" tabindex="4" v-model="initCatalogTime"></fg-input>
                      </div>
                    </div>
                    <br />
                    <input
                      type="submit"
                      class="btn btn-fill"
                      :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                      value="Catalogar"
                    />
                  </div>
                </form>
              </card>
            </div>
          </div>
      </div>
      <div class="col-md-9 col-sm-12">
        <h4 class="card-title">
          <small :class="'title-'+theme">Catalagoção Velas por Cor:</small>
        </h4>
        <card :class="'card-catalog-'+theme">
          <div class="card-header">
            <h4 class="card-title">
              <button
                class="btn btn-round btn-fill"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                @click.prevent="openModal('commands')"
              >
                <i class="nc-icon nc-controller-modern"></i> Comandos
              </button>
              <div align="right">
                Total:
                <button class="btn btn-green"></button>
                -
                {{ candlesColor['green'] ? candlesColor['green'].length : 0 }}
                |
                <button
                  class="btn btn-red"
                ></button>
                -
                {{ candlesColor['red'] ? candlesColor['red'].length : 0 }}
              </div>
            </h4>
          </div>
          <el-dialog center title :visible.sync="modals.commands">
            <span>
              <card>
                <h4 class="card-title text-center">Como selecionar Velas por Cor ?</h4>
                <br />
                <div class="card-body">
                  <h5>
                    <strong>Clique ou Avance via tecla Tab</strong> sobre cada
                    <strong>Caixa de Seleção de Vela</strong>, utilizando
                    um dos seguintes comandos:
                  </h5>
                  <div class="col-md-12">
                    <h4 class="card-title">
                      <small>Via Mouse:</small>
                    </h4>
                    <hr />
                    <ul class="col-md-12">
                      <li>
                        <h5>
                          <strong>Vela Doji:</strong>
                          Botão
                          <strong>Central</strong> do Mouse (quando existente).
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Vermelha:</strong>
                          Botão
                          <strong>Direito</strong> do Mouse.
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Verde:</strong>
                          Botão
                          <strong>Esquerdo</strong> do Mouse.
                        </h5>
                      </li>
                    </ul>
                  </div>
                  <br />
                  <div class="col-md-12">
                    <h4 class="card-title">
                      <small>Via Teclado:</small>
                    </h4>
                    <hr />
                    <ul class="col-md-12">
                      <li>
                        <h5>
                          <strong>Vela Doji:</strong>
                          Tecla
                          <strong>1</strong> do Teclado ou Numpad.
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Vermelha:</strong>
                          Tecla
                          <strong>2</strong> do Teclado ou Numpad.
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <strong>Vela Verde:</strong>
                          Tecla
                          <strong>3</strong> do Teclado ou Numpad.
                        </h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </card>
            </span>
          </el-dialog>
          <ul id="candles" class="card-body">
            <li
              v-for="(candle, index) in candles"
              :key="index"
              v-on:mousedown.left="selectCandleColor('green', index)"
              v-on:mousedown.middle="selectCandleColor('doji', index)"
              v-on:mousedown.right="selectCandleColor('red', index)"
              v-on:keyup.49="selectCandleColor('doji', index)"
              v-on:keyup.50="selectCandleColor('red', index)"
              v-on:keyup.51="selectCandleColor('green', index)"
              v-on:keyup.97="selectCandleColor('doji', index)"
              v-on:keyup.98="selectCandleColor('red', index)"
              v-on:keyup.99="selectCandleColor('green', index)"
              v-on:contextmenu.prevent
            >
              <button
                type="button"
                :title="'Fechamento: ' + candle.timeOnHover"
                :class="'btn btn-sm btn-' + candle.color"
              >
                <samp>{{ candle.time }}</samp>
              </button>
            </li>
            <li key="plus">
              <button
                class="btn btn-social btn-round"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                @click="addCandle()"
              >
                <i class="fa fa-plus"></i>
              </button>
            </li>
          </ul>
        </card>
      </div>
    </div>
    <!-- <br /> -->
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <h4 class="card-title text-center">Ciclos</h4>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <h4 class="card-title text-center">Triplicações</h4>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <p class="text-center font-weight-bold h5">Ciclos Azul e Rosa</p>
          <h6 class="percentage-total">Total: {{ totalsPinkAndBlueCycles }}</h6>
          <h6 align="right" class="percentage-group" :class="'header-' + theme">
            <button class="btn btn-blue btn-sm">
              {{
                cyclesColor["Ciclo Azul"] ? cyclesColor["Ciclo Azul"].length : 0
              }}
            </button>
            {{ showBluesCyclesPercentages }}%
            <button class="btn btn-pink btn-sm">
              {{
                cyclesColor["Ciclo Rosa"] ? cyclesColor["Ciclo Rosa"].length : 0
              }}
            </button>
            {{ showPinksCyclesPercentages }}%
          </h6>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li
              v-for="(cycle, index) in filteredPinkAndBlueCycles"
              :key="index"
            >
              <button
                type="button"
                :title="'Fechamento: ' + cycle.timeOnHover"
                :class="'btn btn-sm btn-' + objectColor[cycle.label]"
              >
                <samp>{{ cycle.time }}</samp>
              </button>
            </li>
          </ul>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <p class="text-center font-weight-bold h5">
            Triplicação dos Ciclos Azul e Rosa
          </p>
          <h6 class="percentage-total">
            Total: {{ triplicationsBlueAndPinkCycles.length }}
          </h6>
          <h6 align="right" class="percentage-group" :class="'header-' + theme">
            <button class="btn btn-green btn-md"></button>
            {{ triplicationPercentage.blueAndPinkCycles }}%
            <button class="btn btn-danger btn-md"></button>
            {{ nonTriplicationPercentage.blueAndPinkCycles }}%
          </h6>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li
              v-for="(triplication, index) in triplicationsBlueAndPinkCycles"
              :key="index"
            >
              <button
                type="button"
                :title="'Fechamento: ' + triplication.timeOnHover"
                :class="
                  'btn btn-sm btn-' +
                    (triplication.type === 'Triplicação' ? 'success' : 'danger')
                "
              >
                <samp>{{ triplication.time }}</samp>
              </button>
            </li>
          </ul>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <p class="text-center font-weight-bold h5">Ciclos Verde e Laranja</p>
          <h6 class="percentage-total">
            Total: {{ totalsGreenAndOrangeCycles }}
          </h6>
          <h6 align="right" class="percentage-group" :class="'header-' + theme">
            <button class="btn btn-green btn-sm">
              {{
                cyclesColor["Ciclo Verde"]
                  ? cyclesColor["Ciclo Verde"].length
                  : 0
              }}
            </button>
            {{ showGreensCyclesPercentages }}%
            <button class="btn btn-warning btn-sm">
              {{
                cyclesColor["Ciclo Laranja"]
                  ? cyclesColor["Ciclo Laranja"].length
                  : 0
              }}
            </button>
            {{ showOrangesCyclesPercentages }}%
          </h6>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li
              v-for="(cycle, index) in filteredGreenAndOrangeCycles"
              :key="index"
            >
              <button
                type="button"
                :title="'Fechamento: ' + cycle.timeOnHover"
                :class="'btn btn-sm btn-' + objectColor[cycle.label]"
              >
                <samp>{{ cycle.time }}</samp>
              </button>
            </li>
          </ul>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <p class="text-center font-weight-bold h5">
            Triplicação dos Ciclos Verde e Laranja
          </p>
          <h6 class="percentage-total">
            Total: {{ triplicationsGreenAndOrangeCycles.length }}
          </h6>
          <h6 align="right" class="percentage-group" :class="'header-' + theme">
            <button class="btn btn-green btn-md"></button>
            {{ triplicationPercentage.greenAndOrangeCycles }}%
            <button class="btn btn-danger btn-md"></button>
            {{ nonTriplicationPercentage.greenAndOrangeCycles }}%
          </h6>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li
              v-for="(triplication, index) in triplicationsGreenAndOrangeCycles"
              :key="index"
            >
              <button
                type="button"
                :title="'Fechamento: ' + triplication.timeOnHover"
                :class="
                  'btn btn-sm btn-' +
                    (triplication.type === 'Triplicação' ? 'success' : 'danger')
                "
              >
                <samp>{{ triplication.time }}</samp>
              </button>
            </li>
          </ul>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <p class="text-center font-weight-bold h5">Reagrupamento Cíclico</p>
          <h6 class="percentage-total">Total: {{ totalsGroupCycles }}</h6>
          <h6 align="right" class="percentage-group" :class="'header-' + theme">
            <button class="btn btn-blue btn-sm">
              {{
                cyclesColor["Ciclo Azul"] ? cyclesColor["Ciclo Azul"].length : 0
              }}
            </button>
            {{ showBluesCyclesPercentagesWithAll }}%
            <button class="btn btn-pink btn-sm">
              {{
                cyclesColor["Ciclo Rosa"] ? cyclesColor["Ciclo Rosa"].length : 0
              }}
            </button>
            {{ showPinksCyclesPercentagesWithAll }}%
            <button class="btn btn-green btn-sm">
              {{
                cyclesColor["Ciclo Verde"]
                  ? cyclesColor["Ciclo Verde"].length
                  : 0
              }}
            </button>
            {{ showGreensCyclesPercentagesWithAll }}%
            <button class="btn btn-warning btn-sm">
              {{
                cyclesColor["Ciclo Laranja"]
                  ? cyclesColor["Ciclo Laranja"].length
                  : 0
              }}
            </button>
            {{ showOrangesCyclesPercentagesWithAll }}%
          </h6>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li v-for="(cycle, index) in cycles" :key="index">
              <button
                type="button"
                :title="'Fechamento: ' + cycle.timeOnHover"
                :class="'btn btn-sm btn-' + objectColor[cycle.label]"
              >
                <samp>{{ cycle.time }}</samp>
              </button>
            </li>
          </ul>
        </card>
      </div>

      <div class="col-md-6 col-sm-12">
        <card :class="'card-catalog-' + theme">
          <p class="text-center font-weight-bold h5">
            Triplicação do Reagrupamento Cíclico
          </p>
          <h6 class="percentage-total">Total: {{ triplications.length }}</h6>
          <h6 align="right" class="percentage-group" :class="'header-' + theme">
            <button class="btn btn-green btn-md"></button>
            {{ triplicationPercentage.allCycles }}%
            <button class="btn btn-danger btn-md"></button>
            {{ nonTriplicationPercentage.allCycles }}%
          </h6>
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li v-for="(triplication, index) in triplications" :key="index">
              <button
                type="button"
                :title="'Fechamento: ' + triplication.timeOnHover"
                :class="
                  'btn btn-sm btn-' +
                    (triplication.type === 'Triplicação' ? 'success' : 'danger')
                "
              >
                <samp>{{ triplication.time }}</samp>
              </button>
            </li>
          </ul>
        </card>
      </div>
    </div>

    <div class="copyright text-right" :class="'footer-' + theme">
      &copy; TopTrader 2020. Feito com
      <i class="fa fa-heart heart"></i> pela equipe TopDev.
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import { Select, Option, Dialog } from "element-ui";
import "bootstrap/dist/css/bootstrap.css";
import JsonExcel from "vue-json-excel";
import _ from "lodash";
import crypto from "crypto";
import SignalsCard from "./SignalsCard";
import {
  Card,
  Switch as LSwitch,
  FormGroupInput as FgInput,
  FilteredDropdown,
  AlertsIQ
} from "src/components/index";

import { ACTIVES } from "src/utils/currencies/constants-iq-option";

Vue.component("downloadExcel", JsonExcel);

export default {
  name: "cataloging-tool",
  components: {
    FgInput,
    FilteredDropdown,
    Card,
    LSwitch,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    AlertsIQ,
    SignalsCard
  },
  props: {},
  data() {
    return {
      modals: {
        commands: false,
        configs: false
      },
      howManyCandles: 120,
      selectedAsset: 1,
      selectedCandleTime: 60,
      initCatalogTime: "00:00",
      gotLastCandles: false,
      gotLastInstruments: false,
      gotLastBinaryTurbo: false,
      selectedCandleColor: "",
      instruments: [],
      candles: [{}],
      lastCandle: { id: 0 },
      json_fields: {
        Hora: "time",
        Abertura: "open",
        Minima: "min",
        Maxima: "max",
        Fechamento: "close",
        Cor: "color"
      },
      triplications: [{}],
      triplicationsBlueAndPinkCycles: [{}],
      triplicationsGreenAndOrangeCycles: [{}],
      maxContinuousTriplication: 0,
      maxAlternatesTriplication: 0,
      maxNonTriplication: 0,
      totalsPinkAndBlueCycles: 0,
      totalsGreenAndOrangeCycles: 0,
      triplicationPercentage: {
        allCycles: 0,
        blueAndPinkCycles: 0,
        greenAndOrangeCycles: 0
      },
      nonTriplicationPercentage: {
        allCycles: 0,
        blueAndPinkCycles: 0,
        greenAndOrangeCycles: 0
      },
      candlesColor: {},
      cyclesColor: {},
      cycleType: {
        "Ciclo Azul": "Triplicação",
        "Ciclo Rosa": "Não Triplicação",
        "Ciclo Verde": "Triplicação",
        "Ciclo Laranja": "Não Triplicação"
      },
      objectColor: {
        "Ciclo Azul": "blue",
        "Ciclo Rosa": "pink",
        "Ciclo Verde": "green",
        "Ciclo Laranja": "warning",
        green: "success",
        red: "danger",
        doji: "light"
      },
      cycles: [],
      selects: {
        candles: [
          { value: "green", label: "Verde" },
          { value: "red", label: "Vermelha" },
          { value: "doji", label: "Doji" }
        ],
        selectedCycles: [],
        cycles: [
          { value: "blue", label: "Ciclo Azul" },
          { value: "pink", label: "Ciclo Rosa" },
          { value: "orange", label: "Ciclo Laranja" },
          { value: "green", label: "Ciclo Verde" }
        ],
        selectedStrategies: "",
        strategies: [{ value: "triplication", label: "Triplicação" }],
        assets: ACTIVES,
        candleTimes: [
          { value: 60, label: "1 minuto" },
          { value: 120, label: "2 minutos" },
          { value: 300, label: "5 minutos" },
          { value: 600, label: "10 minutos" },
          { value: 900, label: "15 minutos" },
          { value: 1800, label: "30 minutos" },
          { value: 3600, label: "1 hora" },
          { value: 7200, label: "2 horas" },
          { value: 14400, label: "4 horas" },
          { value: 28800, label: "8 horas" },
          { value: 43200, label: "12 horas" },
          { value: 86400, label: "1 dia" },
          { value: 604800, label: "1 semana" },
          { value: 2592000, label: "1 mês" }
        ]
      },
      mhiResults: {
        mhi: { info: { wins: 0, losts: 0 }, result: [] },
        mhi2: { info: { wins: 0, losts: 0 }, result: [] },
        mhi3: { info: { wins: 0, losts: 0 }, result: [] }
      },
      historyAnalises: [
        { type: "", time: "" },
        { type: "", time: "" },
        { type: "", time: "" }
      ],
      candleAndTimeOrders: {
        color: "",
        nextOrder: {
          hour: "",
          date: ""
        },
        firstMartingale: {
          hour: "",
          date: ""
        },
        secondMartingale: {
          hour: "",
          date: ""
        }
      },
    };
  },
  beforeMount() {
    if (!this.$auth.user()) {
      return this.$router.push("/login");
    }

  },
  mounted() {
    this.candles = [new Array(parseInt(this.howManyCandles, 10))];
    this.selects.selectedStrategies = ["triplication"];
    this.selects.selectedCycles = [
      { value: "blue", label: "Ciclo Azul" },
      { value: "pink", label: "Ciclo Rosa" },
      { value: "orange", label: "Ciclo Laranja" },
      { value: "green", label: "Ciclo Verde" }
    ]
    this.cycles = [];
    this.triplications = [];
    this.generatedCandleTime()
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    generatedCandleTime() {
      for (let index = 0; index < this.howManyCandles; index++) {
        if (index === 0) {
          let timeToAdd = this.selectedCandleTime > 43200 ? moment().format("DD/MM/YY") : this.initCatalogTime
          this.candles[index] = { color: "", time: timeToAdd, timeOnHover: this.initCatalogTime };
        } else {
          let timeToAdd =
            this.selectedCandleTime !== 2592000 // 1 mes
              ? this.selectedCandleTime > 43200 // maior que 12 horas
                ? moment(this.initCatalogTime, "HH:mm").add(this.selectedCandleTime * index, 's').format("DD/MM/YY")
                : moment(this.initCatalogTime, "HH:mm").add(this.selectedCandleTime * index, 's').format("HH:mm")
              : moment(this.initCatalogTime, "HH:mm").add(this.selectedCandleTime * index, 's').format("MM/YYYY");
          let timeOnHover = moment(this.initCatalogTime, "HH:mm").add(this.selectedCandleTime * index, 's').format("L");
          this.candles[index] = { color: "", time: timeToAdd, timeOnHover: timeOnHover };
        }
      }
      this.gotLastCandles = true;
    },
    addCandle() {
      let timeToAdd = ''
      let timeOnHover = ''
      if (this.selectedCandleTime !== 2592000) { // diferente de 1 mes
        if (this.selectedCandleTime > 43200) { // maior que 12 horas
          let splitDate = this.candles[this.candles.length - 1].time.split("/")
          splitDate = moment(splitDate, "L")
          timeToAdd = moment(splitDate).add(this.selectedCandleTime, 's').format("DD/MM/YY")
          timeOnHover = moment(splitDate).add(this.selectedCandleTime, 's').format("L");
        } else { // Antes de 12 H retorno sempre em HH:mm
          let splitDate = this.candles[this.candles.length - 1].timeOnHover.split("/")
          let splitTime = this.candles[this.candles.length - 1].time.split(":")
          let joinDateTime = this.candles[this.candles.length - 1].timeOnHover + ' ' + (this.candles[this.candles.length - 1].time)
          timeOnHover = moment(joinDateTime, "DD/MM/YYYY HH:mm").add(this.selectedCandleTime, 's').format("DD/MM/YY");
          timeToAdd =  moment(this.candles[this.candles.length - 1].time, "HH:mm").add(this.selectedCandleTime, 's').format("HH:mm")
        }
      } else {
        timeToAdd = moment(this.candles[this.candles.length - 1].time, "HH:mm").add(this.selectedCandleTime, 's').format("MM/YYYY");
      }

      this.candles.splice(0, 1);
      this.candles.push({ color: "", time: timeToAdd, timeOnHover });
      this.cutrimAlgorithm();
      this.setMhiStrategy();
    },
    onSubmitForm() {
      this.candles = [{}];
      this.candlesColor = {},
      this.cyclesColor = {},
      this.maxContinuousTriplication = 0,
      this.maxAlternatesTriplication = 0,
      this.maxNonTriplication = 0,
      this.totalsPinkAndBlueCycles = 0,
      this.totalsGreenAndOrangeCycles = 0,
      this.triplicationPercentage = {
        allCycles: 0,
        blueAndPinkCycles: 0,
        greenAndOrangeCycles: 0
      }
      this.nonTriplicationPercentage = {
        allCycles: 0,
        blueAndPinkCycles: 0,
        greenAndOrangeCycles: 0
      },
      this.triplications = [{}],
      this.triplicationsBlueAndPinkCycles = [{}],
      this.triplicationsGreenAndOrangeCycles = [{}],
      this.cycles = []
      this.generatedCandleTime();
    },
    selectCandleColor(color, index) {
      this.candles[index].color = color;
      this.selectedCandleColor = color;
      this.candlesColor = _.groupBy(this.candles, "color");
      this.cutrimAlgorithm();
      this.setMhiStrategy();
    },
    cutrimAlgorithm() {
      if (this.candles.length >= 3) {
        this.cycles = [];
        this.getCycles();
        this.cycles = _.filter(this.cycles, function(o) {
          return o.label !== "neutral";
        });
        this.cyclesColor = _.groupBy(this.cycles, "label"); // para estatisticas das cores dos ciclos
        if (this.cycles.length >= 3) {
          this.triplications = [];
          this.getTriplications(this.triplications, this.cycles);
          this.triplications = _.filter(this.triplications, function(o) {
            return o.label !== "neutral";
          });
          this.setPercentagesTriplications(this.triplications, "allCycles");
        }
        if (this.filteredPinkAndBlueCycles.length >= 3) {
          this.triplicationsBlueAndPinkCycles = [];
          this.getTriplications(
            this.triplicationsBlueAndPinkCycles,
            this.filteredPinkAndBlueCycles
          );
          this.triplicationsBlueAndPinkCycles = _.filter(
            this.triplicationsBlueAndPinkCycles,
            function(o) {
              return o.label !== "neutral";
            }
          );
          this.setPercentagesTriplications(
            this.triplicationsBlueAndPinkCycles,
            "blueAndPinkCycles"
          );
        }
        if (this.filteredGreenAndOrangeCycles.length >= 3) {
          this.triplicationsGreenAndOrangeCycles = [];
          this.getTriplications(
            this.triplicationsGreenAndOrangeCycles,
            this.filteredGreenAndOrangeCycles
          );
          this.triplicationsGreenAndOrangeCycles = _.filter(
            this.triplicationsGreenAndOrangeCycles,
            function(o) {
              return o.label !== "neutral";
            }
          );
          this.setPercentagesTriplications(
            this.triplicationsGreenAndOrangeCycles,
            "greenAndOrangeCycles"
          );
        }
        this.getTotalCyclesPars();
      }
    },
    getTotalCyclesPars() {
      if (
        this.totalsPinkAndBlueCycles ===
          this.filteredPinkAndBlueCycles.length &&
        this.totalsGreenAndOrangeCycles ===
          this.filteredGreenAndOrangeCycles.length
      ) {
        return null;
      }

      this.totalsPinkAndBlueCycles = this.filteredPinkAndBlueCycles.length || 0;
      this.totalsGreenAndOrangeCycles =
        this.filteredGreenAndOrangeCycles.length || 0;
    },
    getCodeFromName(name) {
      return ACTIVES.filter(currency => currency.label === name)[0].value;
    },
    getNameFromCode(code) {
      return ACTIVES.filter(currency => currency.value === code)[0].label;
    },
    setCycle(
      value,
      label,
      initPositionFuture,
      lastPosition,
      colorFirstPosition
    ) {
      const lastCycle = _.last(this.cycles);
      if (value !== "") {
        let breakPattern = true;
        if (lastCycle !== undefined) {
          if (
            (lastCycle.value === "blue1" && colorFirstPosition === "green") ||
            (lastCycle.value === "blue2" && colorFirstPosition === "red")
          ) {
            breakPattern = false;
          }
          if (
            "Ciclo Verde" === lastCycle.label &&
            (label === "Ciclo Laranja" || label === "Ciclo Verde")
          ) {
            breakPattern = false;
          }
        }
        if (breakPattern) {
          this.cycles.push({
            value: value,
            label: label,
            type: this.cycleType[label],
            time: this.candles[lastPosition].time,
            timeOnHover: this.candles[lastPosition].timeOnHover
          });
        } else {
          if (
            lastCycle.label === "Ciclo Azul" ||
            (lastCycle.label === "Ciclo Verde" && label === "Ciclo Laranja")
          ) {
            initPositionFuture = lastPosition - 1;
          }
        }
      }
      if (label === "neutral") {
        this.cycles.push({
          value: value,
          label: label,
          time: this.candles[lastPosition].time,
          timeOnHover: this.candles[lastPosition].timeOnHover
        });
      }

      return initPositionFuture;
    },
    getCycle(p1, p2, p3) {
      const value =
        this.candles[p1].color +
        "|" +
        this.candles[p2].color +
        "|" +
        this.candles[p3].color;
      const response = {
        nextPosition: 0,
        value: "",
        label: "",
        firstColor: this.candles[p1].color
      };
      switch (value) {
        // Cycle Blue 1
        case "green|green|green":
          response.value = "blue1";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Blue 2
        case "red|red|red":
          response.value = "blue2";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Pink 1
        case "green|green|red":
          response.value = "pink1";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;

        // Cycle Pink 2
        case "red|red|green":
          response.value = "pink2";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;
        // Cycle Green 1
        case "red|green|red":
          response.value = "green1";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Green 2
        case "green|red|green":
          response.value = "green2";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Orange 1
        case "green|red|red":
          response.value = "orange1";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // Cycle Orange 2
        case "red|green|green":
          response.value = "orange2";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // No cycle
        default:
          response.value = "";
          response.label = "";
          response.nextPosition = p2;
      }
      return response;
    },

    getCycles() {
      // tranform arrays in 3 candles
      let p1 = 0;
      let p2 = p1 + 1;
      let p3 = p2 + 1;
      let newPosition = 0;
      let response = {};
      while (p3 < this.candles.length) {
        response = this.getCycle(p1, p2, p3);
        newPosition = this.setCycle(
          response.value,
          response.label,
          response.nextPosition,
          p3,
          response.firstColor
        );
        p1 = newPosition;
        p2 = p1 + 1;
        p3 = p2 + 1;
      }
    },
    setTriplication(
      triplicationsData,
      cyclesData,
      value,
      label,
      initPositionFuture,
      lastPosition,
      typeFirstPosition
    ) {
      const lastTriplication = _.last(triplicationsData);
      let breakPattern = true;
      if (lastTriplication !== undefined) {
        if (
          (lastTriplication.value === "blue1" &&
            typeFirstPosition === "Triplicação") ||
          (lastTriplication.value === "blue2" &&
            typeFirstPosition === "Não Triplicação")
        ) {
          breakPattern = false;
        }
        if (
          "Ciclo Verde" === lastTriplication.label &&
          (label === "Ciclo Laranja" || label === "Ciclo Verde")
        ) {
          breakPattern = false;
        }
      }
      if (breakPattern) {
        triplicationsData.push({
          value: value,
          label: label,
          type: this.cycleType[label],
          time: cyclesData[lastPosition].time,
          timeOnHover: cyclesData[lastPosition].timeOnHover
        });
      } else {
        if (
          lastTriplication.label === "Ciclo Azul" ||
          (lastTriplication.label === "Ciclo Verde" &&
            label === "Ciclo Laranja")
        ) {
          initPositionFuture = lastPosition - 1;
        }
      }

      return initPositionFuture;
    },
    getTriplication(cyclesData, p1, p2, p3) {
      const value =
        cyclesData[p1].type +
        "|" +
        cyclesData[p2].type +
        "|" +
        cyclesData[p3].type;
      let response = {
        nextPosition: 0,
        value: "",
        label: "",
        firstType: cyclesData[p1].type
      };
      switch (value) {
        // Cycle Blue 1
        case "Triplicação|Triplicação|Triplicação":
          response.value = "blue1";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Blue 2
        case "Não Triplicação|Não Triplicação|Não Triplicação":
          response.value = "blue2";
          response.label = "Ciclo Azul";
          response.nextPosition = p3 + 1;
          break;

        // Cycle Pink 1
        case "Triplicação|Triplicação|Não Triplicação":
          response.value = "pink1";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;

        // Cycle Pink 2
        case "Não Triplicação|Não Triplicação|Triplicação":
          response.value = "pink2";
          response.label = "Ciclo Rosa";
          response.nextPosition = p3;
          break;
        // Cycle Green 1
        case "Não Triplicação|Triplicação|Não Triplicação":
          response.value = "green1";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Green 2
        case "Triplicação|Não Triplicação|Triplicação":
          response.value = "green2";
          response.label = "Ciclo Verde";
          response.nextPosition = p3;
          break;
        // Cycle Orange 1
        case "Triplicação|Não Triplicação|Não Triplicação":
          response.value = "orange1";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // Cycle Orange 2
        case "Não Triplicação|Triplicação|Triplicação":
          response.value = "orange2";
          response.label = "Ciclo Laranja";
          response.nextPosition = p2;
          break;
        // No cycle
        default:
          response.value = "";
          response.label = "";
          response.nextPosition = p2;
      }
      return response;
    },
    getTriplications(triplicationsData, cyclesData) {
      // tranform arrays in 3 candles
      let p1 = 0;
      let p2 = p1 + 1;
      let p3 = p2 + 1;
      let newPosition = 0;
      let response = {};
      while (p3 < cyclesData.length) {
        response = this.getTriplication(cyclesData, p1, p2, p3);
        newPosition = this.setTriplication(
          triplicationsData,
          cyclesData,
          response.value,
          response.label,
          response.nextPosition,
          p3,
          response.firstType
        );
        p1 = newPosition;
        p2 = p1 + 1;
        p3 = p2 + 1;
      }
    },
    setPercentagesTriplications(triplicationsData, percentagePropertyName) {
      const totalTriplications = _.countBy(triplicationsData, "type");
      if (totalTriplications["Triplicação"] !== undefined) {
        this.triplicationPercentage[percentagePropertyName] = Math.round(
          (totalTriplications["Triplicação"] * 100) / triplicationsData.length
        );
      } else {
        this.triplicationPercentage[percentagePropertyName] = 0;
      }
      if (totalTriplications["Não Triplicação"] !== undefined) {
        this.nonTriplicationPercentage[percentagePropertyName] = Math.round(
          (totalTriplications["Não Triplicação"] * 100) /
            triplicationsData.length
        );
      } else {
        this.nonTriplicationPercentage[percentagePropertyName] = 0;
      }
    },
    setMhiStrategy() {
      this.mhiResults.mhi.result = [];
      this.mhiResults.mhi.info = { wins: 0, losts: 0 };
      this.mhiResults.mhi2.result = [];
      this.mhiResults.mhi2.info = { wins: 0, losts: 0 };
      this.mhiResults.mhi3.result = [];
      this.mhiResults.mhi3.info = { wins: 0, losts: 0 };

      const candleHooks = [];
      let triesMhi = 0;
      let triesMhi2 = 0;
      let triesMhi3 = 0;
      let wonForMhi = false;
      let wonForMhi2 = false;
      let wonForMhi3 = false;

      const compareColorForMhi = candle => {
        // opera somente em candleHooks nas posições 0, 1 e 2
        if (
          candleHooks[0] &&
          candleHooks[1] &&
          candleHooks[2] &&
          candleHooks[0].id < candleHooks[1].id &&
          candleHooks[1].id < candleHooks[2].id &&
          !wonForMhi
        ) {
          const allTogether =
            candleHooks[0].color + candleHooks[1].color + candleHooks[2].color;
          const contRed = (allTogether.match(/red/g) || []).length;
          const contGreen = (allTogether.match(/green/g) || []).length;

          if (contRed > 1) {
            ++triesMhi;
            // ganho maioria vermelho
            if ("green" === candle.color) {
              wonForMhi = true;
              triesMhi = 0;
              this.mhiResults.mhi.result.push({
                time: candle.time,
                color: "green",
                timeOnHover: moment.unix(candle.from).format("L"),
                id: candle.id
              });
              this.mhiResults.mhi.info.wins = this.mhiResults.mhi.info.wins + 1;
            }
          }
          if (contGreen > 1) {
            ++triesMhi;
            // ganho maioria verde
            if ("red" === candle.color) {
              wonForMhi = true;
              triesMhi = 0;
              this.mhiResults.mhi.result.push({
                time: candle.time,
                color: "green",
                timeOnHover: moment.unix(candle.from).format("L"),
                id: candle.id
              });
              this.mhiResults.mhi.info.wins = this.mhiResults.mhi.info.wins + 1;
            }
          }

          if (triesMhi > 2) {
            // perda
            triesMhi = 0;
            wonForMhi = false;
            this.mhiResults.mhi.result.push({
              time: candle.time,
              color: "red",
              timeOnHover: moment.unix(candle.from).format("L"),
              id: candle.id
            });
            this.mhiResults.mhi.info.losts = this.mhiResults.mhi.info.losts + 1;
          }
        } else {
          // não fazer nada
          return null;
        }
      };

      const compareColorForMhi2 = candle => {
        // opera somente em candleHooks nas posições 3, 4 e 5
        if (
          candleHooks[3] &&
          candleHooks[4] &&
          candleHooks[5] &&
          candleHooks[3].id < candleHooks[4].id &&
          candleHooks[4].id < candleHooks[5].id &&
          !wonForMhi2
        ) {
          const allTogether =
            candleHooks[3].color + candleHooks[4].color + candleHooks[5].color;
          const contRed = (allTogether.match(/red/g) || []).length;
          const contGreen = (allTogether.match(/green/g) || []).length;

          if (contRed > 1) {
            ++triesMhi2;
            // ganho maioria vermelho
            if ("green" === candle.color) {
              wonForMhi2 = true;
              triesMhi2 = 0;
              this.mhiResults.mhi2.result.push({
                time: candle.time,
                color: "green",
                timeOnHover: moment.unix(candle.from).format("L"),
                id: candle.id
              });
              this.mhiResults.mhi2.info.wins =
                this.mhiResults.mhi2.info.wins + 1;
            }
          }
          if (contGreen > 1) {
            ++triesMhi2;
            // ganho maioria verde
            if ("red" === candle.color) {
              wonForMhi2 = true;
              triesMhi2 = 0;
              this.mhiResults.mhi2.result.push({
                time: candle.time,
                color: "green",
                timeOnHover: moment.unix(candle.from).format("L"),
                id: candle.id
              });
              this.mhiResults.mhi2.info.wins =
                this.mhiResults.mhi2.info.wins + 1;
            }
          }

          if (triesMhi2 > 2) {
            // perda
            triesMhi2 = 0;
            wonForMhi2 = false;
            this.mhiResults.mhi2.result.push({
              time: candle.time,
              color: "red",
              timeOnHover: moment.unix(candle.from).format("L"),
              id: candle.id
            });
            this.mhiResults.mhi2.info.losts =
              this.mhiResults.mhi2.info.losts + 1;
          }
        } else {
          // não fazer nada
          return null;
        }
      };

      const compareColorForMhi3 = candle => {
        // opera somente em candleHooks nas posições 6, 7 e 8
        if (
          candleHooks[6] &&
          candleHooks[7] &&
          candleHooks[8] &&
          candleHooks[6].id < candleHooks[7].id &&
          candleHooks[7].id < candleHooks[8].id &&
          !wonForMhi3
        ) {
          const allTogether =
            candleHooks[6].color + candleHooks[7].color + candleHooks[8].color;
          const contRed = (allTogether.match(/red/g) || []).length;
          const contGreen = (allTogether.match(/green/g) || []).length;

          if (contRed > 1) {
            ++triesMhi3;
            // ganho maioria vermelho
            if ("green" === candle.color) {
              wonForMhi3 = true;
              triesMhi3 = 0;
              this.mhiResults.mhi3.result.push({
                time: candle.time,
                color: "green",
                timeOnHover: moment.unix(candle.from).format("L"),
                id: candle.id
              });
              this.mhiResults.mhi3.info.wins =
                this.mhiResults.mhi3.info.wins + 1;
            }
          }
          if (contGreen > 1) {
            ++triesMhi3;
            // ganho maioria verde
            if ("red" === candle.color) {
              wonForMhi3 = true;
              triesMhi3 = 0;
              this.mhiResults.mhi3.result.push({
                time: candle.time,
                color: "green",
                timeOnHover: moment.unix(candle.from).format("L"),
                id: candle.id
              });
              this.mhiResults.mhi3.info.wins =
                this.mhiResults.mhi3.info.wins + 1;
            }
          }

          if (triesMhi3 > 2) {
            // perda
            triesMhi3 = 0;
            wonForMhi3 = false;
            this.mhiResults.mhi3.result.push({
              time: candle.time,
              color: "red",
              timeOnHover: moment.unix(candle.from).format("L"),
              id: candle.id
            });
            this.mhiResults.mhi3.info.losts =
              this.mhiResults.mhi3.info.losts + 1;
          }
        } else {
          // não fazer nada
          return null;
        }
      };

      // 1 minuto
      if (this.selectedCandleTime === 60 && this.candles.length > 3) {
        this.candles.map((candle, index) => {
          switch (candle.time.substr(-1)) {
            case "0":
              wonForMhi = false;
              compareColorForMhi(candle);
              break;
            case "1":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }
              wonForMhi2 = false;
              compareColorForMhi2(candle);
              break;
            case "2":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }
              candleHooks[0] = candle;

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              wonForMhi3 = false;
              compareColorForMhi3(candle);
              break;
            case "3":
              candleHooks[1] = candle;

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }

              break;
            case "4":
              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }

              candleHooks[2] = candle;
              candleHooks[3] = candleHooks[0];
              candleHooks[4] = candleHooks[1];
              candleHooks[5] = candleHooks[2];
              candleHooks[6] = candleHooks[0];
              candleHooks[7] = candleHooks[1];
              candleHooks[8] = candleHooks[2];

              break;
            case "5":
              wonForMhi = false;
              compareColorForMhi(candle);
              break;
            case "6":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }

              wonForMhi2 = false;
              compareColorForMhi2(candle);
              break;
            case "7":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }
              candleHooks[0] = candle;

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              wonForMhi3 = false;
              compareColorForMhi3(candle);
              break;
            case "8":
              candleHooks[1] = candle;

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }
              break;
            case "9":
              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }
              candleHooks[2] = candle;
              candleHooks[3] = candleHooks[0];
              candleHooks[4] = candleHooks[1];
              candleHooks[5] = candleHooks[2];
              candleHooks[6] = candleHooks[0];
              candleHooks[7] = candleHooks[1];
              candleHooks[8] = candleHooks[2];

              break;
            default:
              break;
          }
        });
      }

      // 5 minutos
      if (this.selectedCandleTime === 300 && this.candles.length > 3) {
        this.candles.map((candle, index) => {
          switch (candle.time.substr(-2)) {
            case "00":
              wonForMhi = false;
              compareColorForMhi(candle);
              break;
            case "05":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }
              wonForMhi2 = false;
              compareColorForMhi2(candle);
              break;
            case "10":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              wonForMhi3 = false;
              compareColorForMhi3(candle);
              break;
            case "15":
              candleHooks[0] = candle;

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }

              break;
            case "20":
              candleHooks[1] = candle;
              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }

              break;
            case "25":
              candleHooks[2] = candle;
              candleHooks[3] = candleHooks[0];
              candleHooks[4] = candleHooks[1];
              candleHooks[5] = candle;
              candleHooks[6] = candleHooks[0];
              candleHooks[7] = candleHooks[1];
              candleHooks[8] = candle;
              break;
            case "30":
              wonForMhi = false;
              compareColorForMhi(candle);

              break;
            case "35":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }
              wonForMhi2 = false;
              compareColorForMhi2(candle);

              break;
            case "40":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              wonForMhi3 = false;
              compareColorForMhi3(candle);
              break;
            case "45":
              candleHooks[0] = candle;

              if (!wonForMhi2) {
                compareColorForMhi2(candle);
              }

              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }

              break;
            case "50":
              candleHooks[1] = candle;
              if (!wonForMhi3) {
                compareColorForMhi3(candle);
              }

              break;
            case "55":
              candleHooks[2] = candle;
              candleHooks[3] = candleHooks[0];
              candleHooks[4] = candleHooks[1];
              candleHooks[5] = candle;
              candleHooks[6] = candleHooks[0];
              candleHooks[7] = candleHooks[1];
              candleHooks[8] = candle;

              break;
            default:
              break;
          }
        });
      }

      // 15 minutos
      if (this.selectedCandleTime === 900 && this.candles.length > 3) {
        let tempHook1 = {};
        let tempHook2 = {};

        this.candles.map((candle, index) => {
          switch (candle.time.substr(-2)) {
            case "00":
              wonForMhi = false;
              compareColorForMhi(candle);
              break;
            case "15":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }
              tempHook1 = candle;
              break;
            case "30":
              if (!wonForMhi) {
                compareColorForMhi(candle);
              }

              tempHook2 = candle;

              break;
            case "45":
              candleHooks[0] = tempHook1;
              candleHooks[1] = tempHook2;
              candleHooks[2] = candle;

              break;

            default:
              break;
          }
        });
      }

      this.setSignalOrders();
    },
    setSignalOrders() {
      const signalState = {};

      signalState.nextSignal = {
        color: "",
        nextOrder: {
          hour: "",
          date: ""
        },
        firstMartingale: {
          hour: "",
          date: ""
        },
        secondMartingale: {
          hour: "",
          date: ""
        }
      };

      signalState.variationAnalysis = false;

      let mhi2Results = this.mhiResults.mhi2.result;
      let mhi3Results = this.mhiResults.mhi3.result;

      const getMinorColor = (color1, color2, color3 = "") => {
        const allTogether = color1 + color2 + color3;
        const contRed = (allTogether.match(/red/g) || []).length;
        const contGreen = (allTogether.match(/green/g) || []).length;
        const contDoji = (allTogether.match(/doji/g) || []).length;

        if (contDoji > 1) return undefined;
        if (contDoji > contGreen + contRed) return undefined;
        if (contRed < contGreen) return "red";
        if (contGreen < contRed) return "green";

        return undefined;
      };

      const setNextSignalOrder = (
        minorColorFromGroup,
        nextTimeOrder,
        nextTimeFirstMartingale,
        nextTimeSecondMartingale
      ) => {
        signalState.nextSignal = {
          color: minorColorFromGroup,
          nextOrder: {
            hour: nextTimeOrder.format("LT"),
            date: nextTimeOrder.format("DD/MM")
          },
          firstMartingale: {
            hour: nextTimeFirstMartingale.format("LT"),
            date: nextTimeFirstMartingale.format("DD/MM")
          },
          secondMartingale: {
            hour: nextTimeSecondMartingale.format("LT"),
            date: nextTimeSecondMartingale.format("DD/MM")
          }
        };
      };

      const setHistorySignals = array => {
        this.historyAnalises = array;
      };

      const watchForNextOrder = results => {
        // add && mhi.color === "red"
        const mhiChose = signalState.variationAnalysis
          ? results.filter(
              (mhi, index) => results.length - 1 == index && mhi.color === "red"
            )
          : results.filter(
              (mhi, index) =>
                results.length - 1 == index &&
                results.length - 2 == index &&
                mhi.color === "red"
            );

        if (mhiChose.length > 0) {
          const candleGroupForCompare = signalState.variationAnalysis
            ? this.candles.filter(
                (candle, index) =>
                  mhiChose[0].id - 1 == candle.id || mhiChose[0].id == candle.id
              )
            : this.candles.filter(
                (candle, index) =>
                  mhiChose[1].id - 1 == candle.id || mhiChose[1].id == candle.id
              );

          const minorColorFromGroup = getMinorColor(
            candleGroupForCompare[0].color,
            candleGroupForCompare[1].color
          );

          if (minorColorFromGroup != undefined) {
            const nextTimeOrder = moment
              .unix(candleGroupForCompare[1].from)
              .add(this.selectedCandleTime * 3, "s");

            const nextTimeFirstMartingale = moment(nextTimeOrder).add(
              this.selectedCandleTime,
              "s"
            );

            const nextTimeSecondMartingale = moment(nextTimeOrder).add(
              this.selectedCandleTime * 2,
              "s"
            );

            setNextSignalOrder(
              minorColorFromGroup,
              nextTimeOrder,
              nextTimeFirstMartingale,
              nextTimeSecondMartingale
            );
          } else if (minorColorFromGroup == undefined) {
            const groupForCompare = this.candles.filter(
              (candle, index) =>
                (mhiChose[1].id - 1 == candle.id ||
                  mhiChose[1].id == candle.id ||
                  mhiChose[1].id + 1 == candle.id) &&
                !candle.doji
            );

            if (groupForCompare.length > 2) {
              const minorColorFromGroupOfThree = getMinorColor(
                groupForCompare[0].color,
                groupForCompare[1].color,
                groupForCompare[2].color
              );

              const nextTimeOrder = moment
                .unix(groupForCompare[2].from)
                .add(this.selectedCandleTime * 3, "s");

              const nextTimeFirstMartingale = moment(nextTimeOrder).add(
                this.selectedCandleTime,
                "s"
              );

              const nextTimeSecondMartingale = moment(nextTimeOrder).add(
                this.selectedCandleTime * 2,
                "s"
              );

              setNextSignalOrder(
                minorColorFromGroupOfThree,
                nextTimeOrder,
                nextTimeFirstMartingale,
                nextTimeSecondMartingale
              );
            }
          }
        }
      };

      const setHistoryAnalysis = () => {
        // comparar para perda em variação 1 dois vermelhos juntos em qualquer MHI2-MHI3
        // após ordenar um único array com ordem crescente de acordo com id de cada objecto
        const historyArray = [];

        const oneErrorVariant = mhiResults => {
          mhiResults.map((mhi, index) => {
            // percorrer
            const indexPlusOne = index - 1 >= 0;

            if (
              indexPlusOne &&
              mhi.color == "green" &&
              mhiResults[index - 1].color == "red"
            ) {
              historyArray.push({ ...mhi, type: "win" });
            }

            if (
              indexPlusOne &&
              mhi.color == "red" &&
              mhiResults[index - 1].color == "red"
            ) {
              historyArray.push({ ...mhi, type: "lost" });
            }
          });
        };

        const twoErrorsVariant = mhiResults => {
          mhiResults.map((mhi, index) => {
            // percorrer
            const indexPlusOne = index - 2 >= 0;

            if (
              indexPlusOne &&
              mhi.color == "green" &&
              mhiResults[index - 1].color == "red" &&
              mhiResults[index - 2].color == "red"
            ) {
              historyArray.push({ ...mhi, type: "win" });
            }

            if (
              indexPlusOne &&
              mhi.color == "red" &&
              mhiResults[index - 1].color == "red" &&
              mhiResults[index - 2].color == "red"
            ) {
              historyArray.push({ ...mhi, type: "lost" });
            }
          });
        };

        if (signalState.variationAnalysis) {
          oneErrorVariant(mhi2Results);
          oneErrorVariant(mhi3Results);
        }
        if (!signalState.variationAnalysis) {
          twoErrorsVariant(mhi2Results);
          twoErrorsVariant(mhi3Results);
        }

        const sortArrayById = historyArray.sort((a, b) => {
          if (a.id < b.id) return -1;
          if (a.id > b.id) return 1;
          return 0;
        });
        setHistorySignals(sortArrayById);
      };

      if (mhi2Results.length > 1) {
        watchForNextOrder(mhi2Results);
        this.candleAndTimeOrders = signalState.nextSignal;
        setHistoryAnalysis();
      }

      if (!signalState.nextSignal.color && mhi3Results.length > 1) {
        watchForNextOrder(mhi3Results);
        this.candleAndTimeOrders = signalState.nextSignal;
        setHistoryAnalysis();
      }
    }
  },

  computed: {
    theme() {
      return this.$auth.user().layout;
    },
    showActiveInfo() {
      return this.instruments
        .filter(elem => elem.id === this.lastCandle.active_id)
        .map(elem => elem.image_prefix + elem.image)[0];
    },
    filteredPinkAndBlueCycles() {
      return this.cycles.filter(
        cycle => cycle.value.includes("pink") || cycle.value.includes("blue")
      );
    },
    filteredGreenAndOrangeCycles() {
      return this.cycles.filter(
        cycle => cycle.value.includes("orange") || cycle.value.includes("green")
      );
    },
    showGreensCandlesPercentages() {
      const greensTotals = this.candles.length
        ? this.candles.filter(candle => candle.color === "green").length
        : null;
      const redsTotals = this.candles.length
        ? this.candles.filter(candle => candle.color === "red").length
        : null;

      if (!greensTotals || !redsTotals) {
        return null;
      }

      return Math.round((greensTotals * 100) / (greensTotals + redsTotals));
    },
    showRedsCandlesPercentages() {
      const greensTotals = this.candles.length
        ? this.candles.filter(candle => candle.color === "green").length
        : null;
      const redsTotals = this.candles.length
        ? this.candles.filter(candle => candle.color === "red").length
        : null;

      if (!greensTotals || !redsTotals) {
        return null;
      }

      return Math.round((redsTotals * 100) / (greensTotals + redsTotals));
    },
    showBluesCyclesPercentages() {
      const bluesTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("blue")).length
        : null;
      const pinksTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("pink")).length
        : null;

      if (!bluesTotals || !pinksTotals) {
        return null;
      }
      return Math.round((bluesTotals * 100) / (bluesTotals + pinksTotals));
    },
    showPinksCyclesPercentages() {
      const bluesTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("blue")).length
        : null;
      const pinksTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("pink")).length
        : null;

      if (!pinksTotals || !pinksTotals) {
        return null;
      }

      return Math.round((pinksTotals * 100) / (bluesTotals + pinksTotals));
    },
    showGreensCyclesPercentages() {
      const greensTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("green")).length
        : null;
      const orangesTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("orange")).length
        : null;

      if (!greensTotals || !orangesTotals) {
        return null;
      }

      return Math.round((greensTotals * 100) / (greensTotals + orangesTotals));
    },
    showOrangesCyclesPercentages() {
      const greensTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("green")).length
        : null;
      const orangesTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("orange")).length
        : null;

      if (!greensTotals || !orangesTotals) {
        return null;
      }

      return Math.round((orangesTotals * 100) / (greensTotals + orangesTotals));
    },
    showBluesCyclesPercentagesWithAll() {
      const bluesTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("blue")).length
        : null;
      const pinksTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("pink")).length
        : null;
      const greensTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("green")).length
        : null;
      const orangesTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("orange")).length
        : null;

      if (!bluesTotals || !pinksTotals || !greensTotals || !orangesTotals) {
        return null;
      }

      return Math.round(
        (bluesTotals * 100) /
          (bluesTotals + pinksTotals + greensTotals + orangesTotals),
        1
      );
    },
    showPinksCyclesPercentagesWithAll() {
      const bluesTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("blue")).length
        : null;
      const pinksTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("pink")).length
        : null;
      const greensTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("green")).length
        : null;
      const orangesTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("orange")).length
        : null;

      if (!bluesTotals || !pinksTotals || !greensTotals || !orangesTotals) {
        return null;
      }

      return Math.round(
        (pinksTotals * 100) /
          (bluesTotals + pinksTotals + greensTotals + orangesTotals),
        1
      );
    },
    showGreensCyclesPercentagesWithAll() {
      const bluesTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("blue")).length
        : null;
      const pinksTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("pink")).length
        : null;
      const greensTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("green")).length
        : null;
      const orangesTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("orange")).length
        : null;

      if (!bluesTotals || !pinksTotals || !greensTotals || !orangesTotals) {
        return null;
      }

      return Math.round(
        (greensTotals * 100) /
          (bluesTotals + pinksTotals + greensTotals + orangesTotals),
        1
      );
    },
    showOrangesCyclesPercentagesWithAll() {
      const bluesTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("blue")).length
        : null;
      const pinksTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("pink")).length
        : null;
      const greensTotals = this.cycles
        ? this.cycles.filter(cycle => cycle.value.includes("green")).length
        : null;
      const orangesTotals = this.cyclesColor
        ? this.cycles.filter(cycle => cycle.value.includes("orange")).length
        : null;

      if (!bluesTotals || !pinksTotals || !greensTotals || !orangesTotals) {
        return null;
      }

      return Math.round(
        (orangesTotals * 100) /
          (bluesTotals + pinksTotals + greensTotals + orangesTotals),
        1
      );
    },
    showMhiWinsPercentages() {
      const totalResults =
        this.mhiResults.mhi.info.wins + this.mhiResults.mhi.info.losts;

      if (!totalResults) {
        return 0;
      }

      return ((this.mhiResults.mhi.info.wins / totalResults) * 100).toFixed(0);
    },
    showMhi2WinsPercentages() {
      const totalResults =
        this.mhiResults.mhi2.info.wins + this.mhiResults.mhi2.info.losts;

      if (!totalResults) {
        return 0;
      }

      return ((this.mhiResults.mhi2.info.wins / totalResults) * 100).toFixed(0);
    },
    showMhi3WinsPercentages() {
      const totalResults =
        this.mhiResults.mhi3.info.wins + this.mhiResults.mhi3.info.losts;

      if (!totalResults) {
        return 0;
      }

      return ((this.mhiResults.mhi3.info.wins / totalResults) * 100).toFixed(0);
    },
    showMhiLostsPercentages() {
      const totalResults =
        this.mhiResults.mhi.info.wins + this.mhiResults.mhi.info.losts;

      if (!totalResults) {
        return 0;
      }

      return ((this.mhiResults.mhi.info.losts / totalResults) * 100).toFixed(0);
    },
    showMhi2LostsPercentages() {
      const totalResults =
        this.mhiResults.mhi2.info.wins + this.mhiResults.mhi2.info.losts;

      if (!totalResults) {
        return 0;
      }

      return ((this.mhiResults.mhi2.info.losts / totalResults) * 100).toFixed(
        0
      );
    },
    showMhi3LostsPercentages() {
      const totalResults =
        this.mhiResults.mhi3.info.wins + this.mhiResults.mhi3.info.losts;

      if (!totalResults) {
        return 0;
      }

      return ((this.mhiResults.mhi3.info.losts / totalResults) * 100).toFixed(
        0
      );
    },
    totalsGroupCycles() {
      return this.totalsPinkAndBlueCycles + this.totalsGreenAndOrangeCycles;
    },
    only120Candles() {
      // candles visibility limited to 120 for performance fix
      return this.candles.slice(this.candles.length - 120);
    }
  }
};
</script>
<style>
body,
html {
  overflow-x: hidden;
}

.main-black {
  background: #181b1f;
  color: #fff;
}
.main-light {
  background: #d8d8d8;
}
.title-black {
  color: #fff;
}
.title-light {
  color: #03141e;
}
.header-black {
  color: #ffffff;
}
.header-light {
  color: #03141e;
}
.card-catalog-black {
  background-color: #2a2b31;
}

.percentage-total {
  position: relative;
  top: 1.2rem;
}

.percentage-group button {
  font-size: 1em;
  line-height: 0.8;
  font-weight: bold !important;
}

ul#candles li {
  display: inline;
}

ul#cycles li {
  width: auto !important;
}

ul#triplication li {
  width: auto !important;
}

@media (max-width: 480px) {
  ul#candles li {
    width: 40% !important;
  }
}

ul#cycles li {
  float: left;
  display: inline;
}
@media (max-width: 480px) {
  ul#cycles li {
    width: 40% !important;
  }
}

ul#triplication li {
  float: left;
  display: inline;
}
@media (max-width: 480px) {
  ul#triplication li {
    width: 50% !important;
  }
}
input {
  background-color: #f7f7f7 !important;
  color: #3e3e3e !important;
}
p .titles {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/NewManualCataloging.vue